/**
 * Collector'larin paylastigi DOM yardimcilari.
 * Kisisel veri toplanmamasi icin input degerleri hicbir zaman okunmaz.
 */
import trackerConfig from "../config";

const MAX_TEXT_LENGTH = 80;
const SENSITIVE_INPUT_TYPES = ["password", "email", "tel", "hidden"];
const SENSITIVE_NAME_REGEX = /pass|card|cvv|cvc|iban|tckn|ssn|secret|token|otp/i;

/** Element metni; maskelenmis alanlarda ve hassas inputlarda bos doner. */
export function elementText(element) {
    if (!element) return "";
    if (trackerConfig.isMasked(element)) return "";
    const tag = (element.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select") return "";
    let text = element.innerText || element.textContent || "";
    text = text.replace(/\s+/g, " ").trim();
    return text.slice(0, MAX_TEXT_LENGTH);
}

/** Element icin kisa, okunabilir CSS secici uretir. */
export function elementSelector(element) {
    if (!element || !element.tagName) return "";
    const tag = element.tagName.toLowerCase();
    if (element.id) return tag + "#" + element.id;
    const className = typeof element.className === "string" ? element.className.trim() : "";
    if (!className) return tag;
    const first = className.split(/\s+/).slice(0, 2).join(".");
    return first ? tag + "." + first : tag;
}

/** Click event'i icin gonderilecek element ozeti. */
export function describeElement(element, event) {
    if (!element) return null;
    const className = typeof element.className === "string" ? element.className.trim().slice(0, 120) : "";
    const info = {
        tag: (element.tagName || "").toLowerCase(),
        id: element.id ? String(element.id).slice(0, 120) : "",
        class: className,
        text: elementText(element),
        selector: elementSelector(element),
        href: "",
        x: 0,
        y: 0,
    };
    const anchor = element.closest ? element.closest("a[href]") : null;
    if (anchor) info.href = String(anchor.getAttribute("href") || "").slice(0, 500);
    if (event) {
        info.x = Math.round(event.clientX || 0);
        info.y = Math.round(event.clientY || 0);
    }
    return info;
}

/** Form ozeti; form degerleri asla toplanmaz. */
export function describeForm(form) {
    if (!form) return null;
    return {
        id: form.id ? String(form.id).slice(0, 120) : "",
        name: form.name ? String(form.name).slice(0, 120) : "",
        action: form.getAttribute ? String(form.getAttribute("action") || "").slice(0, 300) : "",
    };
}

/** Form alaninin adi; hassas alanlarda maskelenir. */
export function fieldName(field) {
    if (!field) return "";
    const type = (field.type || "").toLowerCase();
    const name = String(field.name || field.id || "").slice(0, 80);
    if (SENSITIVE_INPUT_TYPES.indexOf(type) !== -1) return "[masked]";
    if (SENSITIVE_NAME_REGEX.test(name)) return "[masked]";
    return name;
}

export function isExternalLink(href) {
    if (!href) return false;
    try {
        const url = new URL(href, window.location.href);
        if (url.protocol !== "http:" && url.protocol !== "https:") return false;
        return url.hostname !== window.location.hostname;
    } catch (e) {
        return false;
    }
}

export function throttle(fn, waitMs) {
    let last = 0;
    return function () {
        const now = Date.now();
        if (now - last < waitMs) return;
        last = now;
        fn.apply(null, arguments);
    };
}



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/dom.js
// module id = null
// module chunks = 